var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useState } from "react";
import classNames from "classnames";
import Icon from '../Icon';
import Box from "../Box";
import Transition from '../Transition';
import MenuItem from "./MenuItem";
var timer;
var SubMenu = function (_a) {
    var mode = _a.mode, title = _a.title, items = _a.items, isOpened = _a.isOpened, itemKey = _a.itemKey, currentKey = _a.currentKey, onItemClick = _a.handleClick;
    var _b = useState(isOpened), subMenuVisible = _b[0], setSubMenuVisible = _b[1];
    var classes = classNames('menu-item submenu-item', {
        'active': currentKey.split("_")[0] === itemKey,
        'is-vertical': mode === 'vertical',
        'is-opened': subMenuVisible
    });
    var handleClick = function (e) {
        e.preventDefault();
        setSubMenuVisible(!subMenuVisible);
    };
    var handleMouse = function (e, toggle) {
        clearTimeout(timer);
        e.preventDefault();
        timer = setTimeout(function () {
            setSubMenuVisible(toggle);
        }, 200);
    };
    var clickEvents = mode === 'vertical' && { onClick: handleClick };
    var hoverEvents = mode === 'horizontal' && {
        onMouseEnter: function (e) { return handleMouse(e, true); },
        onMouseLeave: function (e) { return handleMouse(e, false); }
    };
    var renderChildren = function () {
        var submenuClasses = classNames('submenu', {
            'submenu-visible': subMenuVisible
        });
        var childrenComponent = items.map(function (item) {
            var label = item.label, key = item.key;
            return (React.createElement(React.Fragment, null,
                React.createElement(MenuItem, { label: label, itemKey: "".concat(itemKey, "_").concat(key), currentKey: currentKey, handleClick: function () { return onItemClick("".concat(itemKey, "_").concat(key)); } })));
        });
        return (React.createElement(Transition, { timeout: 300, in: subMenuVisible, animation: "zoom-in-top" },
            React.createElement("ul", { className: submenuClasses }, childrenComponent)));
    };
    return (React.createElement("li", __assign({ key: itemKey, className: classes }, hoverEvents),
        React.createElement(Box, __assign({ className: "submenu-title" }, clickEvents),
            title,
            React.createElement(Icon, { icon: 'angle-down', className: 'arrow-icon' })),
        subMenuVisible && renderChildren()));
};
SubMenu.displayName = 'SubMenu';
export default SubMenu;
